import { TcleKey } from './tcle-print.util';

export interface TcleEntry {
  nome: string;
  driveId: string;
  key: TcleKey | null;
  codigos: number[];   // CD_PROCEDIMENTO (PROC_INTERNO) — match fixo, confiável
  keywords: string[];  // fallback: match por nome quando codigos ainda não preenchido
}

export const TCLE_MAP: TcleEntry[] = [
  {
    nome: 'Inserção de DIU',
    driveId: '13iSUkK9U_wTlmkWeq8ejvoU4lqEjhnc6',
    key: 'diu-insercao',
    codigos: [94010145, 45050173, 45050174],
    keywords: [],
  },
  {
    nome: 'Retirada de DIU',
    driveId: '1WPZON8oajXnyRUMqG-l2r1kfoUW9GXXG',
    key: 'diu-retirada',
    codigos: [45050172],
    keywords: [],
  },
  {
    nome: 'Core Biopsy de Mama',
    driveId: '1b5Ff8gygWk4bYIbhvr-rL0G6NBNZ90QS',
    key: 'core-biopsy-mama',
    codigos: [94010246],
    keywords: [],
  },
  {
    nome: 'Infiltração Articular',
    driveId: '1-7j-DxJme7er12a5LK4Ixqk8v25IPsl8',
    key: 'infiltracao-articular',
    codigos: [13010070, 13010071, 13010072, 5225500068],
    keywords: [],
  },
  {
    nome: 'PAAF de Tireoide',
    driveId: '16dEzXCaJAYsjafym-v3n60vWSfcEu07t',
    key: 'paaf-tireoide',
    codigos: [21010273],
    keywords: [],
  },
  {
    nome: 'Biópsia de Pele - Punch',
    driveId: '1UdojuFEGR2kcy2aWQHfXVPIrwad2PzA_',
    key: 'punch-pele',
    codigos: [94010122],
    keywords: [],
  },
  {
    nome: 'Colonoscopia',
    driveId: '1hL0ythuxVUg0f2OlEpI5XUkTyGu_FNiR',
    key: 'colonoscopia',
    codigos: [95010303, 95010304, 95010308, 95010410],
    keywords: [],
  },
  {
    nome: 'Ecocardiograma',
    driveId: '1Kj26t0Yj1yTvlkanNtX3kzgQ3kHaNRbN',
    key: 'ecocardiograma',
    codigos: [20010133],
    keywords: [],
  },
  {
    nome: 'Endoscopia Digestiva Alta',
    driveId: '1JXie2FpuJ7EmVrokgUswW1rnc8MIKJBl',
    key: 'endoscopia-digestiva',
    codigos: [16020219, 23020148],
    keywords: [],
  },
  {
    nome: 'Radiografia',
    driveId: '1TpAuP95r_-phbtdmmaMQJ_nZSQpYRAQR',
    key: 'radiografia',
    // Excluídos: odontológicos (210, 260, 265, 6511, 93010147, 93010175, 93010209)
    codigos: [
      98010270, 98010252, 98010482, 98010505, 98010506, 98010507, 98010508,
      98010509, 98010510, 98010511, 98010512, 98010513, 98010514, 98010515,
      98010516, 98010517,
      32010010, 32010079, 32010117, 32010150,
      32020015, 32020023, 32020040, 32020066, 32020074, 32020090, 32020104,
      32030037, 32030045, 32030070, 32030071, 32030088, 32030096, 32030100,
      32030118, 32030126, 32030134,
      32040016, 32040032, 32040040, 32040059, 32040067, 32040075, 32040083,
      32040091, 32040105, 32040113, 32040121, 32040148,
      32050038, 32050054,
      32080018, 32089997, 32089998, 32089999, 32090001, 32090002, 32090003,
      40803120, 52230023, 94010234,
    ],
    keywords: [],
  },
  {
    nome: 'Teste Ergométrico',
    driveId: '1xYlU3luuFfwszx4cquWG9fuACJnSMdyp',
    key: 'teste-ergometrico',
    codigos: [20010028],
    keywords: [],
  },
  {
    nome: 'Tomografia Computadorizada',
    driveId: '1eHwu3OGnRChMBEzAXVjFNyQJffXbUX18',
    key: 'tomografia',
    // Excluído: 93010176 (TC ATM Digital — odontológico)
    codigos: [
      34010017, 34010025, 34010033, 34010068, 34010084, 34010092, 34010114, 34010130,
      34011112, 34011113,
      34019901, 34019902, 34019910, 34019911, 34019996, 34019997, 34019998,
      35010001, 35010002, 35010003, 35010004, 35010005, 35010006, 35010007,
      35010008, 35010009, 35010010, 35010011, 35010012,
      36020010, 36020047,
      41101386, 41101387, 41101388, 41101389, 41101390, 41101391, 41101392,
      41101393, 41101394, 41101395, 41101396, 41101397, 41101398,
      98010235, 98010266, 98010267, 98010268, 98010269,
      98010518, 98010519, 98010520, 98010521, 98010527, 98010528, 98010529, 98010530,
      98010531, 98010532, 98010533, 98010534, 98010535, 98010536, 98010537, 98010538,
      98010539, 98010540, 98010541, 98010542, 98010545, 98010546, 98010547, 98010548,
      98010549, 98010550, 98010551, 98010552, 98010553, 98010554, 98010555, 98010556,
      98010557, 98010558, 98010559, 98010560, 98010561, 98010562, 98010563,
      98010601, 98010602, 98010607,
    ],
    keywords: [],
  },
];

function normalizar(texto: string): string {
  return texto.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
}

export function matchTcles(
  procedimentos: { cdProcedimento?: string | number; dsProcedimento?: string; qtProcedimento?: number }[]
): TcleEntry[] {
  const encontrados = new Map<string, TcleEntry>();
  for (const proc of procedimentos) {
    if ((proc.qtProcedimento ?? 0) <= 0) continue;
    const cdProc = Number(proc.cdProcedimento ?? 0);
    const ds = normalizar(proc.dsProcedimento ?? '');
    for (const entry of TCLE_MAP) {
      if (encontrados.has(entry.driveId)) continue;
      const byCode = cdProc > 0 && entry.codigos.includes(cdProc);
      const byName = entry.codigos.length === 0 && entry.keywords.some(kw => ds.includes(normalizar(kw)));
      if (byCode || byName) {
        encontrados.set(entry.driveId, entry);
      }
    }
  }
  return [...encontrados.values()];
}

export function urlTcle(driveId: string): string {
  return `https://drive.google.com/file/d/${driveId}/view`;
}
